/**
 * Shared visual treatment for chord-analysis confidence levels.
 *
 * Applied to function tags, chips, parentheticals, and description lines —
 * anywhere a chord-function label appears. The chord NAME itself is never
 * gated by confidence; only the interpretive labels are.
 *
 * - high   — no class applied; rendered as-is.
 * - medium — 70% opacity to read as "one reading, not the only one". Works on
 *            both light and dark themes because opacity scales the foreground
 *            against whatever surface it sits on.
 * - low    — hidden entirely (extends the existing chromatic-omission pattern).
 *            The container still occupies no space ("better silent than wrong").
 */

.medium {
  opacity: 0.7;
}

.low {
  display: none;
}
